import { render, staticRenderFns } from "./CheckBoxPolicy.vue?vue&type=template&id=8540753c&scoped=true"
import script from "./CheckBoxPolicy.vue?vue&type=script&lang=js"
export * from "./CheckBoxPolicy.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxPolicy.vue?vue&type=style&index=0&id=8540753c&prod&lang=css"
import style1 from "./CheckBoxPolicy.vue?vue&type=style&index=1&id=8540753c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8540753c",
  null
  
)

export default component.exports